/* eslint-disable */
// @ts-nocheck
const Icons = {
  KEYBOARD_ARROW_UP: 'keyboard_arrow_up',
  KEYBOARD_ARROW_DOWN: 'keyboard_arrow_down',
  KEYBOARD_ARROW_LEFT: 'keyboard_arrow_left',
  KEYBOARD_ARROW_RIGHT: 'keyboard_arrow_right',
  CLOSE: 'close',
  SEARCH: 'search',
  IMAGE: 'image',
  SMARTPHONE: 'smartphone',
};
export default Icons;
